export enum SaveStatus {
  Idle = "idle",
  Saving = "saving",
  Saved = "saved",
}

export interface State {
  originalInstructions: string;
  originalIsEnabled: boolean;
  currentInstructions: string;
  isEnabled: boolean;
  saveStatus: SaveStatus;
  error: string | null;
  isEditing: boolean;
  isResetting: boolean;
}

export type Action =
  | { type: "SET_INSTRUCTIONS"; value: string; error: string | null }
  | { type: "SET_ENABLED"; isEnabled: boolean }
  | { type: "START_SAVING" }
  | { type: "SAVE_SUCCESS"; instructions: string; isEnabled: boolean }
  | { type: "SAVE_ERROR"; error: string }
  | { type: "CANCEL" }
  | { type: "START_EDITING" }
  | { type: "CLEAR_RESETTING" };
